import React from "react";
import styles from "./Calculator.module.scss";
import { BiError } from "react-icons/bi";

const Calculator = () => {
  return (
    <div className={styles.calculator}>
      <BiError className={styles.icon} />
      Work under construction. Calculator feature will be added soon.{" "}
    </div>
  );
};

export default Calculator;
